// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datatable[data-v-558cb726]{width:50%}.datatable[data-v-558cb726] tr{height:30px}.datatable[data-v-558cb726] tr:hover{background:#fff!important}.datatable[data-v-558cb726] td,.datatable[data-v-558cb726] th{padding:5px!important}.datatable[data-v-558cb726] td{height:30px}", ""]);
// Exports
module.exports = exports;
